import { render, staticRenderFns } from "./CostElementExtraColumnManger.vue?vue&type=template&id=f2787d18&scoped=true&"
import script from "./CostElementExtraColumnManger.vue?vue&type=script&lang=js&"
export * from "./CostElementExtraColumnManger.vue?vue&type=script&lang=js&"
import style0 from "./CostElementExtraColumnManger.vue?vue&type=style&index=0&id=f2787d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2787d18",
  null
  
)

export default component.exports